// src/components/common/Layout.jsx
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import EmailVerificationBanner from './EmailVerificationBanner';
import OnboardingSystem from '../onboarding/OnboardingSystem';

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    return (
        <div className="flex h-screen bg-gray-100 overflow-hidden">
            <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
            <div className="flex-1 flex flex-col overflow-hidden min-w-0">
                <Header toggleSidebar={() => setSidebarOpen(prev => !prev)} />
                <EmailVerificationBanner />
                <main className="flex-1 overflow-y-auto p-4 sm:p-6">
                    <Outlet />
                </main>
            </div>
            {/* ✅ Onboarding — tour, welcome modal, checklist */}
            <OnboardingSystem />
        </div>
    );
};

export default Layout;